import request from '@/utils/request'


// PC首页获取顶部品牌
export function indexTrademark() {
  return request({
    url: '/pc/index/getTrademark',
    method: 'get',
    // params: query
  })
}

// PC首页获取通知公告
export function indexNotice() {
  return request({
    url: '/pc/index/getNotice',
    method: 'get',
  })
}

// PC首页获取BANNER
export function indexBanner() {
  return request({
    url: '/pc/index/getCarouse',
    method: 'get',
  })
}

// PC首页获取商品分类tree
export function indexCategoryTree() {
  return request({
    url: '/pc/index/getCategoryTree',
    method: 'get',
  })
}
// PC首页获取商品分类tree -- agg
export function indexCategoryTreeAgg() {
  return request({
    url: '/api/goodsCategory/platformTree',
    method: 'get',
  })
}

// PC首页爆品
export function indexHotRecommend() {
  return request({
    url: '/pc/index/getHotRecommendV2',
    method: 'get',
  })
}

// PC首页促销活动
export function goodsPromotion(data) {
  return request({
    url: '/pc/index/getPageGoodsPromotion',
    method: 'get',
    params: data
  })
}
// PC首页优惠券
export function indexCoupon() {
  return request({
    url: '/api/marketingCoupon/selecrUnclaimedCoupon?pageSize=2&pageNum=1',
    method: 'get',
  })
}
// 批量添加购物车
export function saveOrderCar(data) {
  return request({
    url: '/api/pc/orderCart/batchSaveOrderCar',
    method: 'post',
    data:data
  })
}
// 获取LOGO
export function configget() {
  return request({
    url: '/platform/system/config/get',
    method: 'get',
  })
}
// 获取模式
export function getCustomerMerchantType() {
  return request({
    url: '/api/client/getCustomerMerchantType',
    method: 'get',
  })
}
// 切换商户
export function switchMerchant(merchantId) {
  return request({
    url: '/api/customer/switchMerchant/'+merchantId,
    method: 'post',
  })
}
// 广告点击
export function addAdvHits(data) {
  return request({
    url: '/api/client/addAdvHits/'+data.id,
    method: 'post',
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js